import { LocalizePipe } from "@lf-web-components/lf-common-utils-library";
import { lfFilesetLocalize } from "./utils";
let localizePipe: LocalizePipe = new LocalizePipe();

export const UPLOAD_LIMIT: number = 200;
export const MIN_FIELD_WIDTH: number = 120;

export enum EmptyPropertyKey {
  Type = '_none_',
  Status = ''
}

export enum StateContextKey {
  SourceFolderId = "SourceFolderId",
  DestinationFolderId  = "DestinationFolderId",
  FileSetId = "FileSetId"
}

export const AVAILABLE_COLUMNS = {
  'lastModified': {key: 'lastModified', header: localizePipe.transform('lf_fileset_modified_date', lfFilesetLocalize), cell: (element: any) => `${element.properties?.lastModified ?? ""}`},
  'creationDate': {key: 'creationDate', header: localizePipe.transform('lf_fileset_creation_date', lfFilesetLocalize), cell: (element: any) => `${element.properties?.creationDate ?? ""}`},
  'createdBy': {key: 'createdBy', header: localizePipe.transform('lf_fileset_created_by', lfFilesetLocalize), cell: (element: any) => `${element.properties?.createdBy ?? ""}`},
  'entryId': {key: 'entryId', header: localizePipe.transform('lf_fileset_entry_id', lfFilesetLocalize), cell: (element: any) => `${element.properties?.entryId ?? ""}`},
  'extension': {key: 'extension', header: localizePipe.transform('lf_fileset_extension', lfFilesetLocalize), cell: (element: any) => `${element.properties?.extension ?? ""}`},
  'lastModifiedBy': {key: 'lastModifiedBy', header: localizePipe.transform('lf_fileset_modified_by', lfFilesetLocalize), cell: (element: any) => `${element.properties?.lastModifiedBy ?? ""}`},
  'status': {key: 'status', header: localizePipe.transform('lf_fileset_status', lfFilesetLocalize), cell:(element: any) => `${element.status}`},
  'checkedOutBy': {key: 'checkedOutBy', header: localizePipe.transform('lf_fileset_checked_out_by', lfFilesetLocalize), cell:(element: any) => `${element.properties?.checkedOutBy ?? ""}`},
  'electronicFileLastModified': {key: 'electronicFileLastModified', header: localizePipe.transform('lf_fileset_electronic_file_last_modified', lfFilesetLocalize), cell:(element: any) => `${element.properties?.electronicFileLastModified ?? ""}`},
  'hasTags': {key: 'hasTags', header: localizePipe.transform('lf_fileset_has_tags', lfFilesetLocalize), cell:(element: any) => `${element.properties?.hasTags ? localizePipe.transform('lf_fileset_yes', lfFilesetLocalize) : localizePipe.transform('lf_fileset_no', lfFilesetLocalize) ?? ""}`},
  'indexed': {key: 'indexed', header: localizePipe.transform('lf_fileset_indexed', lfFilesetLocalize), cell:(element: any) => `${element.properties?.indexed ? localizePipe.transform('lf_fileset_yes', lfFilesetLocalize) : localizePipe.transform('lf_fileset_no', lfFilesetLocalize) ?? ""}`},
  'latestVersion': {key: 'latestVersion', header: localizePipe.transform('lf_fileset_latest_version', lfFilesetLocalize), cell:(element: any) => `${element.properties?.latestVersion ?? ""}`},
  'locationDescription': {key: 'locationDescription', header: localizePipe.transform('lf_fileset_location_description', lfFilesetLocalize), cell:(element: any) => `${element.properties?.locationDescription ?? ""}`},
  'pages': {key: 'pages', header: localizePipe.transform('lf_fileset_pages', lfFilesetLocalize), cell:(element: any) => `${element.properties?.pages ?? ""}`},
  'template': {key: 'template', header: localizePipe.transform('lf_fileset_template', lfFilesetLocalize), cell:(element: any) => `${element.properties?.template ?? ""}`},
  'totalDocumentSize': {key: 'totalDocumentSize', header: localizePipe.transform('lf_fileset_total_document_size', lfFilesetLocalize), cell:(element: any) => `${element.properties?.totalDocumentSize ?? ""}`},
};

export const DEFAULT_COLUMN_TO_USE = ['status', 'entryId', 'lastModified'];

export interface FileSetEntryViewModel {
  id: string;
  docType: string;
  typeDisplay?: string ;
  name: string;
  status: any;
  viewModel?: any;
  importOrigin: ImportOrigin
  properties: {};
}

export enum ImportOrigin {
  LFREPO = 'LF_REPO',
  USERLOCAL = 'USER_LOCAL'
}

export interface DocumentOrganizerType {
  key: string;
  display: string;
  min: number;
  max: number;
  isRequired: () => boolean
}

export interface InstanceModel {
  State: StateModel;
  Version: string;
  InstanceId: string;
  FileSetId: string;
  Context: any;
}

export interface StateModel {
  FileStates: FileStateModel[];
  StateProperties: StatePropertyModel[];
}

export interface StatePropertyModel {
  StateKey: string;
  StateProperties: StatePropertyValueModel[];
}

export interface FileStateModel {
  FileId: string;
  FileStateValues: FileStateValue[];
}

export interface FileStateValue {
  StateKey: string;
  Value: string;
}

export interface StatePropertyValueModel {
  Key: string;
  DisplayName: string;
  Settings: { [key: string]: any }
}

export interface ColumnModel {
  key: string;
  header: string;
  cell(element): any;
}

export enum ModeType {
  EDIT = 'EDIT',
  READONLY = 'READONLY',
  DISABLED = 'DISABLED',
  PRINT = 'PRINT'
}

export enum ImportMode {
  None = 0,
  Local = 1,
  Repository = 2,
  Both = 3
}

export enum InitErrors {
  NONE = 'NONE',
  RESOURCE_DELETED = 'DELETED',
  RESOURCE_NOT_FOUND = 'NOT_FOUND',
  NONE_INITIALIZED = 'NO_INIT', 
  REJECT_PUBLIC_USERS = 'NO_PUBLIC'
}